exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.arrow-square[data-v-74c99328],ul.arrow[data-v-74c99328],ul.check-circle[data-v-74c99328],ul.check-square[data-v-74c99328],ul.check[data-v-74c99328],ul.chevron[data-v-74c99328],ul.circle[data-v-74c99328],ul.decimal[data-v-74c99328],ul.lower-latin[data-v-74c99328],ul.triangle[data-v-74c99328],ul.upper-latin[data-v-74c99328],ul.upper-roman[data-v-74c99328]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-74c99328]{font-size:1.6em}.booking-information[data-v-74c99328]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74c99328","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/infos/covid19/Home.vue
// module id = 574
// module chunks = 0